module.exports = __webpack_public_path__ + "static/media/Infra-Bold.d1cac95a.otf";